"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const react_1 = require("react");
const theme_1 = require("@zapier/theme");
const containerCss = core_1.css `
  border-radius: 10px 10px 0px 0px;
  padding: 18px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  background-color: ${design_system_1.Colors.brand};
  border: 1px solid ${design_system_1.Colors.brand};
`;
const iconContainerCss = core_1.css `
  margin-right: 15px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  border: 1px solid rgba(255, 255, 255, 0.5);
`;
const contentContainerCss = core_1.css `
  display: flex;
  flex-direction: column;
  text-align: left;
`;
const learnMoreContainerCss = core_1.css `
  margin-left: auto;
`;
const menuContainerCss = core_1.css `
  margin-left: 10px;
  position: relative;
  text-align: left;
`;
const learnMoreBackgroundColor = 'rgba(0,0,0,0.15)';
const learnMoreFocusColor = 'rgba(0,0,0,0.25)';
const learnMoreColorTheme = {
    custom: {
        base: {
            backgroundColor: learnMoreBackgroundColor,
            color: design_system_1.Colors.white,
        },
        disabled: {
            backgroundColor: learnMoreBackgroundColor,
            color: 'rgba(255,255,255,0.8)',
        },
        hover: {
            backgroundColor: learnMoreFocusColor,
            color: design_system_1.Colors.white,
        },
        focus: {
            backgroundColor: learnMoreFocusColor,
            color: design_system_1.Colors.white,
            outlineColor: learnMoreFocusColor,
        },
    },
};
const menuItemCss = {
    border: `2px solid ${design_system_1.Colors.transparent}`,
    color: design_system_1.Colors.grey700,
    cursor: 'pointer',
    fontWeight: 600,
    padding: '10px 20px',
    width: '100%',
    '&:hover': {
        background: design_system_1.Colors.grey100,
    },
    '&:focus': {
        border: `2px solid ${design_system_1.Colors.blue500}`,
        color: design_system_1.Colors.blue500,
    },
    '&:first-of-type': {
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    '&:last-child': {
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
    },
};
const deleteMenuItemCss = (isConfirming) => isConfirming
    ? {
        '&, &:focus': {
            color: design_system_1.Colors.red500,
            borderColor: design_system_1.Colors.red500,
        },
    }
    : {};
function Header({ stepNumber, title, description, onLearnMore, onDelete, }) {
    const [isMenuOpen, setMenuOpen] = react_1.useState(false);
    const onToggleMenu = () => setMenuOpen(b => !b);
    const [isConfirmingDelete, setConfirmingDelete] = react_1.useState(false);
    const onHandleDelete = () => {
        if (isConfirmingDelete) {
            setMenuOpen(false);
            setConfirmingDelete(false);
            if (onDelete) {
                onDelete();
            }
        }
        else {
            setConfirmingDelete(true);
        }
    };
    const onCloseMenu = () => {
        setMenuOpen(false);
        setConfirmingDelete(false);
    };
    const maybeMenuComponent = onDelete ? (common_utils_1.isolateComponent("div", { css: menuContainerCss },
        common_utils_1.isolateComponent(design_system_1.IconButton, { ariaLabel: "Step menu", color: "custom", colorTheme: learnMoreColorTheme, icon: "navMoreHoriz", onClick: onToggleMenu, size: "small" }),
        isMenuOpen && (common_utils_1.isolateComponent(design_system_1.FloatingBox, { align: "right", minWidth: "200px", onClickOutside: onCloseMenu },
            common_utils_1.isolateComponent(common_components_1.Timeout, { delay: theme_1.Duration.confirmationTimeout, isWaiting: isConfirmingDelete, onTimeout: () => {
                    setConfirmingDelete(false);
                } },
                common_utils_1.isolateComponent("button", { css: [menuItemCss, deleteMenuItemCss(isConfirmingDelete)], onClick: onHandleDelete }, isConfirmingDelete ? 'Really delete?' : 'Delete…')))))) : null;
    return (common_utils_1.isolateComponent("div", { css: containerCss },
        common_utils_1.isolateComponent("div", { css: iconContainerCss },
            common_utils_1.isolateComponent(common_components_1.Icon, { color: "rgba(255, 255, 255,0.8)", name: "bolt", size: 32 })),
        common_utils_1.isolateComponent("div", { css: contentContainerCss },
            common_utils_1.isolateComponent(design_system_1.Text, { color: "white", type: "subtitle800" }, stepNumber ? (common_utils_1.isolateComponent("span", null,
                stepNumber,
                ". ",
                title)) : (common_utils_1.isolateComponent("span", null, title))),
            common_utils_1.isolateComponent(design_system_1.Text, { color: "white", type: "altText900" }, description)),
        common_utils_1.isolateComponent("div", { css: learnMoreContainerCss },
            common_utils_1.isolateComponent(design_system_1.Button, { ariaLabel: "Learn more", color: "custom", colorTheme: learnMoreColorTheme, onClick: onLearnMore, size: "small" }, "Learn more")),
        maybeMenuComponent));
}
exports.default = Header;
